export const ACTION_TYPES = {
  GET_CONNECTED_SELLING_POINT: 'sellingPoint/GET_CONNECTED_SELLING_POINT',
  UPDATE_CONNECTED_SELLING_POINT: 'sellingPoint/UPDATE_CONNECTED_SELLING_POINT',
  UPDATE_SELLING_POINT_INFO_BANK: 'sellingPoint/UPDATE_SELLING_POINT_INFO_BANK',
  GET_SELLING_POINT: 'sellingPoint/GET_SELLING_POINT',
  SELECT_SELLING_POINT: 'sellingPoint/SELECT_SELLING_POINT',
  CLEAN_UPDATED_SELLING_POINT_BANK: 'sellingPoint/CLEAN_UPDATED_SELLING_POINT_BANK',
};
